import React, { ReactElement } from 'react';
import { useParams } from 'react-router-dom';
import { CalendrierScolaire, HistoriqueLogs } from '../../../../../common/src/entities';
import ChampFormulaire from '../../Common/ChampFormulaire';
import FormulaireModificationEntite from '../Utils/FormulaireModificationEntite';
import { schemaCalendrierScolaire } from '../../../../../common/src/schemas';
import ChampMultipleJourneePedagogique from '../JourneePedagogique/ChampsMultipleJourneePedagogique';
import ChampMultipleCentreServiceScolaire from '../Css/ChampMultipleCSS';
import LogsLoader, { dateFormatter } from '../Utils/Log';
import { useGetQuery } from '../../../Utils/api';
import { TitreCarte } from '../../Common/TitreCarte';
import { LABEL_COL } from '../constantes';
import { MyPaper } from '../Utils/MyPaper';

export function ChampsCalendrierScolaire(): ReactElement {
    return (
        <div className="pb-5">
            <MyPaper>
                <ChampFormulaire
                    id="annnee_scolaire"
                    titre="Année scolaire"
                    suggestions={['2022-2023', '2023-2024', '2024-2025', '2025-2026', '2026-2027']}
                    isCreatable
                    labelCol={LABEL_COL}
                    estPetit
                />
                <ChampMultipleCentreServiceScolaire
                    labelCol={LABEL_COL}
                    id="centre_service_scolaire"
                    title="Centre de Service Scolaire"
                    maxSize={1}
                    avecUnBouton
                />
                <ChampFormulaire id="notes" titre="Notes" textarea labelCol={LABEL_COL} estPetit />
            </MyPaper>
            <TitreCarte>{'Journée(s) pédagogique(s)'}</TitreCarte>
            <MyPaper>
                <ChampMultipleJourneePedagogique labelCol={LABEL_COL} id="journee" />
            </MyPaper>
        </div>
    );
}

export default function DetailsCalendrierScolaire(): ReactElement {
    const { id } = useParams() as { id: string };
    const listLogs = useGetQuery<HistoriqueLogs[]>(`historique_logs/${id}/calendrier`);
    return (
        <div>
            <FormulaireModificationEntite
                id={+id}
                entite={CalendrierScolaire}
                badges={(f: CalendrierScolaire) => [
                    `Calendrier #${f.id}`,
                    `Dernière modification: ${
                        listLogs.data?.[listLogs.data.length - 1]?.date_modification
                            ? dateFormatter(listLogs.data?.[listLogs.data.length - 1]?.date_modification)
                            : 'Aucune modificiation'
                    } par ${listLogs.data?.[listLogs.data.length - 1]?.nom_usager ?? ''}`,
                ]}
                schema={schemaCalendrierScolaire}
                properties_to_reassign={{
                    centre_service_scolaire: 'fk_centre_service_scolaire',
                }}
            >
                <ChampsCalendrierScolaire />
            </FormulaireModificationEntite>
            <LogsLoader id={id} tableName={'calendrier'} />
        </div>
    );
}
